export default __webpack_public_path__ + "static/media/type-pinnately-compound-leaf.deb3b16a.PNG";